module.exports = __webpack_public_path__ + "static/media/lodging.d8614d49.svg";